export default __webpack_public_path__ + "static/media/vf4.67759ebf.jpg";